import { render } from "./PlaceholderCard.vue?vue&type=template&id=56e95909"
import script from "./PlaceholderCard.vue?vue&type=script&lang=js"
export * from "./PlaceholderCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__